export default __webpack_public_path__ + "a715dbfc5dc6e4742eecc27fdf0f4ad8.png";